import { render, staticRenderFns } from "./methodology.vue?vue&type=template&id=339e6ecc"
import script from "./methodology.vue?vue&type=script&lang=js"
export * from "./methodology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports